/**
 * A `ts_headline` snippet, with its `<<`/`>>` markers drawn rather than printed.
 *
 * Rendered by splitting rather than through `dangerouslySetInnerHTML`, because this text is material
 * somebody else wrote — a Slack message, a meeting note, a file in a space — and may contain anything
 * at all, and the one thing a viewer must never do is execute it. Unbalanced markers — possible if the
 * content itself held a `<<` — fall through as ordinary text instead of swallowing the rest of the line.
 */
export function Snippet({ text }: { text: string }) {
  // Non-greedy and bounded: a matched token can contain `>` (a quoted line, a path), so `[^>]` would
  // drop the highlight, while an unbounded match would let one stray `<<` in the source content
  // swallow the rest of the snippet.
  const parts = text.split(/(<<[\s\S]{0,200}?>>)/g);
  return (
    <>
      {parts.map((part, i) =>
        part.startsWith('<<') && part.endsWith('>>') ? (
          <mark key={i} className="rounded-sm bg-orange-100 px-0.5 text-ink">
            {part.slice(2, -2)}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </>
  );
}
